// TypeScript types matching the backend RefundWorklistView
export interface RefundWorklistView {
  refundId: string;
  caseId: string;
  accountNumber: string;
  refundStatus: string;
  lastName: string;
  firstName: string;
  refundStartDate?: string | null; // ISO date string
  priority: string;
  amount: number;
  sageStatus: string;
  serviceDate?: string | null; // ISO date string
}

// Available refund worklist types based on backend queries
export const REFUND_WORKLIST_TYPES = [
  'Started',
  'InApproval',
  'MyApprovals',
  'Payable',
  'CreditCard',
  'Postable',
  'Rejected'
] as const;

export type RefundWorklistType = typeof REFUND_WORKLIST_TYPES[number];